import { Injectable } from '@angular/core';
import { OfflineDataType } from './enums/offline-data-type.enum';
import { OfflineStoreData } from './models/offline-store-data.model';
import moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class OfflineDataStoreService {
  private storeKeyFormats = new Map<OfflineDataType, Function>();

  constructor() { 
    this.storeKeyFormats.set(OfflineDataType.JobDigitalLogFormResult, (id: number| string) => `offline_JDLFR`);
  }

  private storeKey(dataType: OfflineDataType, id: number | string): string {
    let keyProvider: Function = (id: number| string) => `offline_${dataType.toString()}_${id}`;
    if(this.storeKeyFormats.has(dataType)) {
      keyProvider = this.storeKeyFormats.get(dataType);
    }

    return keyProvider(id);
  }

  public uniqueStoreKey(dataType: OfflineDataType): string {
     return dataType.toString();
  }

  private saveToStore(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(<OfflineStoreData>{
      data,
      updatedOn: moment().format("MM/DD/YYYY HH:mm")
    }));
  }
  
  save(dataType: OfflineDataType, id: number | string, data: any): string {
    const storeKey = this.storeKey(dataType, id);
    this.saveToStore(storeKey, data);
    return storeKey;
  }

  
  saveUnique(dataType: OfflineDataType, data: any): string {  
    const storeKey = this.uniqueStoreKey(dataType); 
    this.saveToStore(storeKey, data);
    return storeKey;
  }
  
  get(dataType: OfflineDataType, id: number | string): OfflineStoreData {
    const storeKey = this.storeKey(dataType, id);
    return this.getByStoreKey(storeKey);
  }

  getByStoreKey(storeKey: string): OfflineStoreData {
    const storeValue = localStorage.getItem(storeKey);
    return <OfflineStoreData>JSON.parse(storeValue);
  }

  getByUniqueStoreKey(dataType: OfflineDataType): OfflineStoreData {
    const storeValue = localStorage.getItem(this.uniqueStoreKey(dataType));
    return <OfflineStoreData>JSON.parse(storeValue);
  }

  discard(dataType: OfflineDataType, id: number | string): void {
    const storeKey = this.storeKey(dataType, id);
    this.discardByStoreKey(storeKey);
  }

  discardByUniqueStoreKey(dataType: OfflineDataType): void {
    const storeKey = this.uniqueStoreKey(dataType);
    this.discardByStoreKey(storeKey);
  }

  discardByStoreKey(storeKey: string): void {
    localStorage.removeItem(storeKey);
  }
}
